// Récupère la position GPS (haute précision). Rejette si refusée / indisponible.
export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("La géolocalisation n'est pas disponible sur cet appareil."));
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      (err) => reject(new Error(err.code === 1
        ? "Vous devez autoriser la géolocalisation pour effectuer votre pointage."
        : "Position GPS indisponible. Vérifiez que le GPS est activé et réessayez.")),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
}
